/* eslint-disable class-methods-use-this */
import { Injectable } from '@angular/core';
import * as Mousetrap from 'mousetrap';

@Injectable({
  providedIn: 'root',
})
export class MousetrapService {
  init(): any {
    const originalStopCallback = Mousetrap.prototype.stopCallback;

    Mousetrap.prototype.stopCallback = function (e, element, combo) {
      if (this.paused) {
        return true;
      }

      return originalStopCallback.call(this, e, element, combo);
    };

    Mousetrap.prototype.pause = function () {
      this.paused = true;
    };

    Mousetrap.prototype.unpause = function () {
      this.paused = false;
    };

    (Mousetrap as any).init();

    return Mousetrap;
  }
}
